import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<NensaTools::NensaClassesCreator @event={{this.model}}/>\n",{ moduleName: "bullitttime-event/templates/event/tools/nensa-classes.hbs" })